var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { ContentEditable } from '@criteria-labs/content-editable';
export function EditableText(_a) {
    var { placeholder, className } = _a, props = __rest(_a, ["placeholder", "className"]);
    return (_jsx("div", { className: clsx([
            className,
            // Base layout
            'relative z-0 block w-full',
            // Background color
            'before:absolute before:-z-10 before:rounded-[calc(theme(borderRadius.lg)-1px)] before:bg-transparent before:focus-within:bg-yellow-50 before:hover:bg-yellow-50 dark:before:focus-within:bg-yellow-700/20 dark:before:hover:bg-yellow-700/20',
            // Background bleed
            'before:-inset-x-[calc(theme(spacing[3.5])-1px)] before:-inset-y-[calc(theme(spacing[2.5])-1px)] sm:before:-inset-x-[calc(theme(spacing[3])-1px)] sm:before:-inset-y-[calc(theme(spacing[1.5])-1px)]',
            // Disabled state
            '[&[contenteditable="false"]]:before:hidden',
            // Focus ring
            'after:pointer-events-none after:absolute after:rounded-lg after:ring-inset after:ring-transparent sm:after:focus-within:ring-2 sm:after:focus-within:ring-blue-500',
            // Focus ring bleed
            'after:-inset-x-[calc(theme(spacing[3.5])-1px)] after:-inset-y-[calc(theme(spacing[2.5])-1px)] sm:after:-inset-x-[calc(theme(spacing[3])-1px)] sm:after:-inset-y-[calc(theme(spacing[1.5])-1px)]'
        ]), children: _jsx(ContentEditable, Object.assign({ placeholder: placeholder ? _jsx("div", { className: "pointer-events-none absolute top-0 opacity-50", children: placeholder }) : undefined, className: "focus:outline-none" }, props)) }));
}
